/// <amd-module name="Analytics/Shared/Common/Utils/ChartDataConverter" />
export function formatData(_data: number[]): number[] {
    return _data.map(d => {
        return toTwoDecimalPoint(d);
    });
}

export function toTwoDecimalPoint(_data: number): number {
    if (_data != null) {
        let fixed = 2;
        fixed = Math.pow(10, fixed);
        return Math.floor(_data * fixed) / fixed;
    } else {
        return _data;
    }
}
